module.exports = __webpack_public_path__ + "img/cloudcc-logo.865e2fbd.svg";